import React from 'react';
import PropTypes from 'prop-types';

import * as Sentry from '@sentry/browser';

import Availability from '../../../../models/availability';
import useAppContext from '../../../../context/useAppContext';
import { ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

import Loading from '../../../../components/loading';

import { ZoneSelector } from '@weezevent/throne';
import SeatMapSelector from './seat-map-selector';

export default function AttendeeMapSelection({ sync, attendees, deselectAttendees, history, selectedAttendees, selectAttendees, inventory, onAttendeeSelected }) {
    const [{ event, organization }] = useAppContext();
    const toast = React.useContext(ToastContext);
    const { t } = useTranslation();

    let [availability, setAvailability] = React.useState(null);
    let [loading, setLoading] = React.useState(true);
    let [zone, setZone] = React.useState({ uuid: 'root' });

    React.useEffect(() => {
        setLoading(true);
        Availability.getAll({
            organizationId: organization.id,
            eventId: event.id,
            inventoryId: inventory.uuid,
            zoneId: zone.uuid === 'root' ? '' : zone.uuid
        })
            .then(av => {
                setAvailability(av);
            })
            .catch(e => {
                Sentry.captureException(e);
                toast.error(t('ticket.attendees.availability_retrieval_error'));
            })
            .finally(() => {
                setLoading(false);
            });
    }, [inventory, zone, sync]);

    if (!availability || loading) {
        return <Loading />;
    }

    if (availability.seats?.length) {
        return (
            <SeatMapSelector
                availability={availability}
                onBack={() => setZone({ uuid: zone.parent })}
                selectedAttendees={selectedAttendees}
                deselectAttendees={deselectAttendees}
                selectAttendees={selectAttendees}
            />
        );
    }

    return (
        <ZoneSelector
            zone={availability}
            onZoneSelected={setZone}
            onBackButtonClicked={() => setZone({ uuid: zone.parent })}
            showAvailability={false}
            defaultColor="#0033fa"
            unavailableColor={false}
        />
    );
}

AttendeeMapSelection.propTypes = {
    sync: PropTypes.any,
    attendees: PropTypes.array,
    deselectAttendees: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    selectedAttendees: PropTypes.array,
    selectAttendees: PropTypes.func.isRequired,
    inventory: PropTypes.object.isRequired,
    onAttendeeSelected: PropTypes.func.isRequired
};
